const KEY = "autoplus-path-trail";
const MAX = 40;

function readPathTrail(): string[] {
  try {
    const raw = sessionStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((entry): entry is string => typeof entry === "string" && entry.startsWith("/"));
  } catch {
    return [];
  }
}

function writePathTrail(trail: string[]) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(trail.slice(-MAX)));
  } catch {
    /* private mode */
  }
}

/** Keep the in-app trail aligned with the page just shown. */
export function syncAppPath(path: string) {
  if (!path.startsWith("/")) return;
  const trail = readPathTrail();
  if (trail[trail.length - 1] === path) return;
  const idx = trail.lastIndexOf(path);
  if (idx >= 0) {
    writePathTrail(trail.slice(0, idx + 1));
    return;
  }
  writePathTrail([...trail, path]);
}

/**
 * Page to open for رجوع.
 * Drops the current page from the trail and returns the one before it.
 */
export function previousAppPath(current: string, fallback: string): string {
  const trail = readPathTrail();
  const stack = trail[trail.length - 1] === current ? trail.slice(0, -1) : trail.slice();
  while (stack.length > 0 && stack[stack.length - 1] === current) stack.pop();
  const prev = stack[stack.length - 1];
  writePathTrail(stack);
  if (!prev || prev === current) return fallback;
  return prev;
}
